import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  CONTEST_DURATION_OPTIONS,
  editSbatGroupContestLessonSelector,
  updateSbatGroupContestLessonDuration,
} from 'features/classCreation';
import Field from 'components/Field';
import Select from 'components/Select';
import styles from './InterviewbitTestDuration.module.scss';

function InterviewbitTestDuration() {
  const dispatch = useDispatch();
  const contestLesson = useSelector(editSbatGroupContestLessonSelector);
  const { duration } = contestLesson || {};

  const handleOnChange = useCallback(
    (option) => {
      dispatch(updateSbatGroupContestLessonDuration(option.value));
    },
    [dispatch]
  );

  return (
    <Field
      label="Contest Duration"
      hint="This duration is applicable to all below contests & Re-attempts"
      className={styles.root}
    >
      <Select
        value={{ value: duration, label: duration + ' Mins' }}
        onChange={handleOnChange}
        options={CONTEST_DURATION_OPTIONS}
      />
    </Field>
  );
}

export default InterviewbitTestDuration;
